<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative">
    <div class="vx-navbar-wrapper" :class="classObj">
      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton z-index-top"
        color="primary"
      >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        >
        </feather-icon>

        <template v-if="windowWidth >= 992">
          <!-- STARRED PAGES - FIRST 10 -->
          <ul class="vx-navbar__starred-pages">
            <draggable
              v-model="starredPagesLimited"
              :group="{ name: 'pinList' }"
              class="flex cursor-move"
            >
              <li
                class="starred-page"
                v-for="page in starredPagesLimited"
                :key="page.url"
              >
                <vx-tooltip :text="page.label" position="bottom" delay=".3s">
                  <feather-icon
                    svgClasses="h-6 w-6"
                    class="p-2 cursor-pointer"
                    :icon="page.labelIcon"
                    @click="$router.push(page.url).catch(() => {})"
                  />
                </vx-tooltip>
              </li>
            </draggable>
          </ul>

          <!-- STARRED PAGES MORE -->
          <div
            class="vx-navbar__starred-pages--more-dropdown p-0"
            v-if="starredPagesMore.length"
          >
            <vs-dropdown vs-custom-content vs-trigger-click>
              <feather-icon
                icon="ChevronDownIcon"
                svgClasses="h-4 w-4"
                class="cursor-pointer p-2"
              ></feather-icon>
              <vs-dropdown-menu class="p-0">
                <ul class="vx-navbar__starred-pages-more--list">
                  <draggable
                    v-model="starredPagesMore"
                    :group="{ name: 'pinList' }"
                    class="cursor-move"
                  >
                    <li
                      class="starred-page--more flex items-center cursor-pointer p-0"
                      v-for="page in starredPagesMore"
                      :key="page.url"
                      @click="$router.push(page.url).catch(() => {})"
                    >
                      <feather-icon
                        svgClasses="h-5 w-5"
                        class="ml-2 mr-1"
                        :icon="page.labelIcon"
                      ></feather-icon>
                      <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                    </li>
                  </draggable>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <!-- <div class="bookmark-container">
          <feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning', {'text-white': navbarColor != '#fff'}]" class="cursor-pointer p-2" @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown" />
                    <div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4" v-if="showBookmarkPagesDropdown">
          <vx-auto-suggest :autoFocus="true" :data="navbarSearchAndPinList" @selected="selected" @actionClicked="actionClicked" inputClassses="w-full" show-action show-pinned background-overlay></vx-auto-suggest>
          </div>
          </div>-->
        </template>

        <vs-spacer />

        <!-- SEARCHBAR -->
        <!-- <div class="search-full-container w-full h-full absolute left-0" :class="{'flex': showFullSearch}" v-show="showFullSearch">
          <vx-auto-suggest
            class="w-full"
            inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
            :autoFocus="showFullSearch"
            :data="navbarSearchAndPinList"
            icon="SearchIcon"
            placeholder="Search..."
            ref="navbarSearch"
            @closeSearchbar="showFullSearch = false"
            @selected="selected"
            background-overlay />
          <div class="absolute right-0 h-full z-50">
              <feather-icon icon="XIcon" class="px-4 cursor-pointer h-full close-search-icon" @click="showFullSearch = false"></feather-icon>
          </div>
      </div>
        <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search mr-4"></feather-icon>-->

        <!--:badge="unreadNotifications.length"-->
        <!-- NOTIFICATIONS -->
        <div @click="getNotifications">
          <vs-dropdown vs-custom-content class="cursor-pointer">
            <feather-icon
              icon="BellIcon"
              class="cursor-pointer mt-1 sm:mr-6 mr-2 notification"
              :badge="notifications_count > 9 ? '9+' : notifications_count"
            ></feather-icon>

            <vs-dropdown-menu
              class="notification-dropdown dropdown-custom vx-navbar-dropdown"
            >
              <div class="notification-top text-center p-5 bg-dark text-white">
                <h3 class="text-white">
                  {{ notifications_count }} {{ $t("labels.new") }}
                </h3>
                <p class="opacity-75">{{ $t("labels.notifications") }}</p>
                <span
                  @click.prevent="allNotificationRead()"
                  class="all-read"
                  :title="$t('labels.mark_all_read')"
                >
                  <feather-icon
                    icon="CheckCircleIcon"
                    class="cursor-pointer mt-1 sm:mr-6 mr-2"
                  ></feather-icon>
                </span>
              </div>

              <VuePerfectScrollbar
                ref="mainSidebarPs"
                class="scroll-area--nofications-dropdown p-0 mb-10"
                :settings="settings"
                v-if="this.notifications"
              >
                <ul class="bordered-items">
                  <li
                    v-for="notification in notifications"
                    :key="notification.index"
                    :class="[
                      'flex justify-between px-4 py-4 notification cursor-pointer',
                      notification.read_at ? '' : 'notification-background',
                    ]"
                  >
                    <div
                      class="flex items-start"
                      @click="goToPage(notification)"
                      v-if="notification.data"
                    >
                      <feather-icon
                        :icon="notification.data.icon"
                        class="title-icon"
                      ></feather-icon>
                      <div class="mx-2">
                        <span
                          :class="[
                            !notification.read_at
                              ? 'notification-title-bold'
                              : '',
                            'font-medium block notification-title',
                          ]"
                        >
                          <span class="goto-page">{{
                            notification.data.title
                          }}</span>
                        </span>
                        <small class="block">{{
                          notification.data.message
                        }}</small>
                        <small>{{
                          notification.created_at | date_format
                        }}</small>
                      </div>
                    </div>
                    <small class="mt-1 whitespace-no-wrap noti-read">
                      <span v-if="notification.read_at">
                        <div
                          title="Mark as unread"
                          @click="toggleNotification(notification.id)"
                          class="notification-read"
                        ></div>
                      </span>
                      <span v-else>
                        <div
                          title="Mark as read"
                          @click="toggleNotification(notification.id)"
                          class="notification-unread"
                        ></div>
                      </span>
                    </small>
                  </li>
                </ul>
              </VuePerfectScrollbar>
              <VuePerfectScrollbar
                ref="mainSidebarPs"
                class="scroll-area--nofications-dropdown p-0 mb-10"
                :settings="settings"
                v-if="!this.notifications"
              >
                <h6>You have no new notifications</h6>
              </VuePerfectScrollbar>
              <div
                class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
                v-if="this.notifications"
              >
                <vs-pagination
                  color="dark"
                  :max="7"
                  :total="totalPage"
                  v-model="currentx"
                  class="mb-1"
                ></vs-pagination>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <!-- USER META -->
        <div
          class="the-navbar__user-meta flex items-center p-0"
          v-if="activeUserInfo.displayName"
        >
          <div class="text-right leading-tight hidden sm:block">
            <!-- <p class="font-semibold">{{ user_displayName }}</p> -->
            <!-- <small>Available</small> -->
          </div>
          <vs-dropdown vs-custom-content class="cursor-pointer">
            <div class="con-img ml-3">
              <vs-avatar
                :text="this.$store.state.userInfo.name"
                color="dark"
                size="40px"
                text-color="white"
              />
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown" ref="vsDropDown">
              <ul style="min-width: 15rem" class="p-0">
                <li
                  class="flex py-2 px-4 cursor-pointer trans-effect"
                  @click="
                    $refs.vsDropDown.dropdownVisible = false;
                    $router.push({ name: 'ChangePassword' });
                  "
                >
                  <feather-icon icon="LockIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">{{ $t("labels.change_password") }}</span>
                </li>
                <vs-divider class="m-1"></vs-divider>

                <li
                  class="flex py-2 px-4 cursor-pointer trans-effect"
                  @click="
                    $refs.vsDropDown.dropdownVisible = false;
                    $router.push({ name: 'Profile' });
                  "
                >
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">{{ $t("labels.profile") }}</span>
                </li>

                <vs-divider class="m-1"></vs-divider>

                <li
                  class="flex py-2 px-4 cursor-pointer trans-effect"
                  @click="logOutConfirm()"
                >
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">{{ $t("labels.logout") }}</span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";

export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      currentx: 1,
      totalPage: 1,
      limit: 10,
      only_unread: null,
      notifications_count: 0,
      notifications: [],
      //mycolor: '#'+(Math.random()*0xFFFFFF<<0).toString(16),
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      unreadNotifications: [],
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
    limit(val) {
      this.currentx = 1;
      this.getNotifications();
    },
    currentx(val) {
      this.getNotifications();
    },
  },
  mounted() {
    this.getNotifications();
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === "dark" ? "#10163a" : this.navbarColor;
    },
    // HELPER
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default") return "navbar-default";
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced";
      else if (this.verticalNavMenuWidth) return "navbar-full";
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },

    // PROFILE
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    user_displayName() {
      return this.activeUserInfo.displayName;
    },
    activeUserImg() {
      return this.$store.state.AppActiveUser.photoURL;
    },
  },
  methods: {
    // API Integration for Notificaions
    async getNotifications() {
      let input = {
        page: this.currentx,
        perPage: this.limit,
      };
      let url = "/notifications";
      let response = await this.getHTTPPostResponse(url, input, "");
      if (response) {
        let perPage = this.limit;
        let totalPage = Math.ceil(response.data.count / perPage);
        this.totalPage = totalPage;
        this.notifications = response.data.notifications;
        this.notifications_count = response.data.unread_count;
      }
    },
    // API Integration for toggle read(notifications)notifications/toggle-read/
    async toggleNotification(nid) {
      let url = "/notifications/toggle-read/" + nid;
      let response = await this.getHTTPGetResponse(url, "");
      if (response) {
        this.getNotifications();
      }
    },
    // API Integration for all notification mark-all-read
    async allNotificationRead() {
      let url = "/notifications/mark-all-read";
      let response = await this.getHTTPGetResponse(url, "");
      if (response) {
        this.getNotifications();
      }
    },
    goToPage(notification) {
      if (!notification.read_at) {
        let url = "/notifications/toggle-read/" + notification.id;
        this.getHTTPGetResponse(url, "").then((res) => {
          this.getNotifications();
        });
      }
      var type = notification.type;
      switch (type) {
        case "App\\Notifications\\ProjectStatusChange":
        case "App\\Notifications\\ProjectConsultantStatusChange":
          this.$router.push({
            name: "Inspection",
            params: { id: notification.data.project_id },
          });
          break;
        case "App\\Notifications\\ProjectQuestionQueryStatusChange":
        case "App\\Notifications\\ProjectQuestionComment":
          this.$router.push({
            name: "Question",
            params: {
              id: notification.data.project_consultant_service_question_id,
            },
          });
          break;
        case "App\\Notifications\\ReportNotification":
          this.$router.push({
            name: "ViewProject",
            params: {
              id: notification.data.project_id,
            },
          });
          break;
        default:
          return "#coming-soon";
      }
    },
    logOutConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: `Logout`,
        acceptText: "Logout",
        cancelText: "Cancel",
        text: this.$t("strings.logout_confirm"),
        accept: this.logout,
      });
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url).catch(() => {});
      this.showFullSearch = false;
    },
    actionClicked(item) {
      // e.stopPropogation();
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " sec ago" : "just now");
      }

      return "Just Now";
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },

    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      let date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date;
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
  },
};
</script>
<style scoped>
.trans-effect {
  transition: all 0.5s ease-in-out;
  color: #000;
}

.trans-effect:hover {
  transition: all 0.5s ease-in-out;
  background-color: rgba(var(--vs-primary), 1);
  color: #000;
}

.feather-icon-badge {
  background-color: rgba(var(--vs-red), 1) !important;
  font-size: 0.85rem !important;
  font-weight: 600;
}

.notification {
  color: rgba(var(--vs-dark), 1);
}

.notification svg {
  width: 28px !important;
  height: 28px !important;
}

.ps-container {
  margin-bottom: 4rem !important;
}

.noti-read span a {
  color: rgba(var(--vs-warning), 1);
}

.notification-unread {
  height: 12px;
  width: 12px;
  background: rgba(var(--vs-dark), 1);
  border-radius: 50%;
  border: 2px solid #fff;
}

.notification-read {
  height: 12px;
  width: 12px;
  background: #c1c1c1;
  border-radius: 50%;
}

.all-read svg {
  width: 20px !important;
  height: 20px !important;
}

.all-read {
  position: absolute;
  top: 28px;
  right: 0;
}

.notification-title-bold {
  font-weight: 600 !important;
}

ul.bordered-items > li:not(:last-of-type):not([class*="shadow"]) {
  border-bottom: 1px solid #f8f8f8;
}

.notification-background {
  background: #e9e9e9;
}

.goto-page {
  text-decoration: none !important;
  color: rgba(var(--vs-dark), 1);
  transition: 0.5s all ease-in-out;
}

.goto-page:hover {
  transition: 0.5s all ease-in-out;
  color: #4f7fa3;
}

.title-icon svg {
  width: 22px !important;
  height: 22px !important;
}

h6 {
  position: fixed;
  top: 108px;
  color: gray;
  left: 88px;
}

.z-index-bottom {
  z-index: 2;
}

.z-index-middle {
  z-index: 4;
}

.z-index-top {
  z-index: 999 !important;
}
/* .vx-navbar-dropdown {
  position: fixed !important;
} */
</style>
